<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <component v-model="editPanel"
                 :id="control.id"
                 :is="component"
                 :control="control"
                 @click.native.prevent
                 @on-create="onCreate"
      />

      <template slot="actions">
        <v-icon>mdi-tune</v-icon>
        <v-icon @click.stop="removeField">mdi-close</v-icon>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <component
            class="column-display"
            :control="control"
            @update-control="updateItem"
            :is="editPanel"
          />
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FieldPreview',
  components: {
    TitleInput: () => import('./inputs/TitleInput.vue'),
    RichTextInput: () => import('./inputs/RichTextInput.vue'),
    LikertQuestionInput: () => import('./inputs/LikertQuestionInput.vue'),
    MCQQuestionInput: () => import('./inputs/MCQQuestionInput.vue'),
    OpenQuestionInput: () => import('./inputs/OpenQuestionInput.vue'),
    TitleEditPanel: () => import('./editPanels/TitleEditPanel.vue'),
    RichTextEditPanel: () => import('./editPanels/RichTextEditPanel.vue'),
    LikertQuestionEditPanel: () => import('./editPanels/LikertQuestionEditPanel.vue'),
    MCQQuestionEditPanel: () => import('./editPanels/MCQQuestionEditPanel.vue'),
    OpenQuestionEditPanel: () => import('./editPanels/OpenQuestionEditPanel.vue')
  },
  props: {
    control: {
      required: true,
      type: Object
    },
    itemIndex: {
      required: true,
      type: Number
    },
    pageIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    editPanel: String
  }),
  computed: {
    component () {
      return this.control.component
    }
  },
  methods: {
    ...mapActions('Questionnaires', [
      'itemRemove',
      'itemChange'
    ]),
    removeField () {
      this.itemRemove({
        pageIndex: this.pageIndex,
        itemIndex: this.itemIndex
      })
    },
    updateItem ({ field, value }) {
      this.itemChange({
        pageIndex: this.pageIndex,
        itemIndex: this.itemIndex,
        field,
        value
      })
    },
    onCreate (panel) {
      this.editPanel = panel
    }
  }
}
</script>

<style>
</style>
